export enum DAHTSecondOpinion {
  No = 'No', // Users with access to learn
  YesPolicyRequirement = 'YesPolicyRequirement', // Intended for executive users and all developers
  Yes = 'Yes', // Executive users of a medical unit, sort of like a medical unit admin
}

export enum DermloopDAHTStudyGroup {
  Intervention = 'intervention',
  Control = 'control',
}

export type DAHTRelevance =
  | 'very-relevant'
  | 'relevant'
  | 'neither-relevant-nor-irrelevant'
  | 'irrelevant'
  | 'very-irrelevant';

export const DAHTDermoscopyRelevance: { value: DAHTRelevance; name: string }[] =
  [
    { name: 'Very irrelevant', value: 'very-irrelevant' },
    { name: 'Irrelevant', value: 'irrelevant' },
    {
      name: 'Neither relevant nor irrelevant',
      value: 'neither-relevant-nor-irrelevant',
    },
    { name: 'Relevant', value: 'relevant' },
    { name: 'Very relevant', value: 'very-relevant' },
  ];

//This allows to create a type and use it with class validator.
export const DAHTNumericalValues = ['1', '2', '3', '4', '5', '6'] as const;
export type DAHTNumericalValue = (typeof DAHTNumericalValues)[number];

export type DAHTSkinLesionExperienceCategory = '0-2' | '3-5' | '6-9' | '10+';

export const DAHTSkinLesionExperienceCategories: {
  value: DAHTSkinLesionExperienceCategory;
  name: string;
}[] = [
  { name: '0–2 years', value: '0-2' },
  { name: '3–5 years', value: '3-5' },
  { name: '6–9 years', value: '6-9' },
  { name: '10+ years', value: '10+' },
];

export type DAHTCaseloadCategory = '1-50' | '51-100' | '101+';

export const DAHTCaseloadCategories: {
  value: DAHTCaseloadCategory;
  name: string;
}[] = [
  { name: '1–50', value: '1-50' },
  { name: '51–100', value: '51-100' },
  { name: '101+', value: '101+' },
];
